import { CURRENT, FAIL, GETALLUSERS, GETONEUSER, LOGIN, LOGOUT, REGISTER } from "../ActionTypes/AuthTypes"

const initialState = {
 user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null,
  token: localStorage.getItem("token") || null,
  isAuth: !!localStorage.getItem("token"),
  load: false,
  errors: [],
  users: [],
  upUser: null
}

const AuthReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REGISTER:
      return {
        ...state,
        load: false,
        user: payload.newUser || payload.user,
        token: payload.token
      }

    case LOGIN:
      if (!payload) {
        console.error('❌ PAYLOAD UNDEFINED DANS LOGIN');
        return state;
      }

      return {
        ...state,
        load: false,
        user: payload.user || payload.found || null,
        token: payload.token,
        isAuth: true,
        errors: []
      }

    case CURRENT:
      return {
        ...state,
        load: false,
        user: payload || payload.user || null,
        isAuth: true
      }

    case FAIL:
      return {
        ...state,
        load: false,
        errors: payload || []
      }

    case LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        isAuth: false,
        errors: [],
        users: []
      }

    case GETALLUSERS:
      return {
        ...state,
        load: false,
        users: payload || []
      }

    case GETONEUSER:
      return {
        ...state,
        load: false,
        upUser: payload || null
      }

    default:
      return state
  }
}

export default AuthReducer